import 'bootstrap/dist/css/bootstrap.min.css';
// import Worker from "worker-loader!./Worker.js";
// import logo from './logo.svg';
import Layout from './components/layout/Layout';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import HomePage from './pages/homePage/HomePage';
import ContactPage from './pages/contactPage/ContactPage';
import CartPage from './pages/cartPage/CartPage';
import OffersPage from './pages/offersPage/OffersPage';
import FilterPage from './pages/filterPage/FilterPage';
import ProductsByCategoryPage from './pages/productsByCategoryPage/ProductsByCategoryPage';
import SignInPage from './pages/signInPage/SignInPage';
import SignUpPage from './pages/signUpPage/SignUpPage';
import AdminPage from './pages/adminPage/AdminPage';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout/>}>
          <Route index element={<HomePage />} />
          <Route path=":category" element={<ProductsByCategoryPage/>} />
          <Route path="contact" element={<ContactPage/>} />
          <Route path="sign-in" element={<SignInPage/>} />
          <Route path="sign-up" element={<SignUpPage/>} />
          <Route path="admin" element={<AdminPage/>} />
          <Route path="cart" element={<CartPage/>} />
          <Route path="offers" element={<OffersPage/>} />
          <Route path="filter">
            <Route path=":name" element={<FilterPage/>} />
            {/* <Route index element={<Rooms/>}/> */}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
